module.exports = __webpack_public_path__ + "static/img/GENOVA-OAK.373644f.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/GENOVA-OAK.png
// module id = IuT/
// module chunks = 0